import firebaseSrv from '@/services/firebaseSrv.js'
// import router from '@/router.js'
// import _ from 'lodash/core'
import cookie from 'vue-cookie'
export const namespaced = true

export const state = {
  entries: {}
}
export const mutations = {
  ALL_ENTRIES(state, entries) {
    state.entries = entries
  },
  UPDATE_ENTRY(state, payload) {
    const entry = state.entries[payload.doc]
    entry[payload.key] = payload.value
  },
  UPDATE_COMMENT(state, payload) {
    const entry = state.entries[payload.doc]
    entry.comment = payload.comment
  }
}
export const getters = {
  entryArray: state => {
    let entries = Object.values(state.entries)
    return entries
  },
  entryCount: (state, getter) => {
    return getter.entryArray.length
  },
  currentEntry: state => ceid => {
    let entriesArray = Object.keys(state.entries)
    return entriesArray.findIndex(needle => needle == ceid)
  },
  filteredEntries: (state, getter) => (key, value) => {
    let filteredArray = getter.entryArray.filter(entry => entry[key] === value)
    return filteredArray.length
  },
  reviewCount: (state, getter) => {
    let filteredArray = getter.entryArray.filter(entry => entry.review === true)
    return filteredArray.length
  },
  commentCount: (state, getter) => {
    let filteredArray = getter.entryArray.filter(
      entry => entry.comment.length > 1
    )
    return filteredArray.length
  }
}

export const actions = {
  getEntries({ commit, getters }) {
    return firebaseSrv.readCompletedEntries().then(docs => {
      commit('ALL_ENTRIES', docs)
      cookie.set('entryCount', getters.entryCount, 1)
      cookie.delete('filterEntries')
      console.log('Cookie: ' + cookie.get('entryCount'))
    })
  },
  getFilteredEntries({ commit }) {
    let key = cookie.get('filterEntries')
    return firebaseSrv.readCompletedFilteredEntries(key).then(docs => {
      console.log(docs)
      commit('ALL_ENTRIES', docs)
    })
  },
  getNotReviewed({ commit }) {
    console.log('getNotFlagedReviewed review.js')
    return firebaseSrv.getNotReviewed().then(docs => {
      console.log(docs)
      commit('ALL_ENTRIES', docs)
    })
  },
  getComment({ commit }) {
    return firebaseSrv.getComment().then(docs => {
      console.log(docs)
      commit('ALL_ENTRIES', docs)
    })
  },
  updateEntry({ commit, dispatch }, payload) {
    return firebaseSrv
      .completedEntryUpdate(payload.key, payload.value, payload.doc)
      .then(() => commit('UPDATE_ENTRY', payload))
      .catch(error => {
        const notification = {
          title: 'There is a problem with your review',
          type: 'error',
          code: error.code,
          message: error.message
        }
        return dispatch('notification/add', notification, { root: true })
      })
  },
  updateStore({ commit }, payload) {
    commit('UPDATE_ENTRY', payload)
  },
  updateComment({ commit }, payload) {
    commit('UPDATE_COMMENT', payload)
  }
}
